import { translate } from '@repo/phrase';
import { Container, Paragraph } from '@repo/ui';

import { AssetDetails } from '@/components/asset-details/asset-details.component';
import { DialogModal } from '@/components/dialog-modal';
import { NoOrderId } from '@/components/routes/no-order-id';

import {
    AssetPendingChangesGuardContext,
    useAssetPendingChangesNavigation,
} from '@/hooks/asset-pending-changes-navigation.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { useOrdersExternalSync } from '@/hooks/orders-external-sync.hooks';

import { useAssetViewCommands } from './asset-view.hooks';

export const AssetView = () => {
    const { assetType, assetId } = useAssetParams();
    const {
        guardPendingChanges,
        isDiscardPromptVisible,
        discardPromptBodyTranslationKey,
        cancelNavigation,
        confirmNavigation,
    } = useAssetPendingChangesNavigation({
        assetId,
        assetType,
    });
    useAssetViewCommands(guardPendingChanges);
    const { data } = useAsset(assetType, assetId);
    useOrdersExternalSync(assetType, assetId, data);

    if (!assetId) {
        return <NoOrderId type={assetType} />;
    }

    return (
        <>
            <AssetPendingChangesGuardContext value={guardPendingChanges}>
                <Container testId={`${assetType}-view`}>
                    <AssetDetails />
                </Container>
            </AssetPendingChangesGuardContext>
            <DialogModal
                visible={isDiscardPromptVisible}
                title={translate('asset_pending_changes_discard_prompt_title')}
                onClose={cancelNavigation}
                primaryButtonProps={{
                    text: translate('asset_details_mode_discard'),
                    onClick: confirmNavigation,
                }}
                secondaryButtonProps={{
                    text: translate('dialog_modal_footer_cancel'),
                    onClick: cancelNavigation,
                }}
            >
                <Paragraph>{translate(discardPromptBodyTranslationKey)}</Paragraph>
            </DialogModal>
        </>
    );
};
